enum ApplicationReviewStatus {
  PendingInfo = 'PendingInfo',
  InformationRequired = 'InformationRequired',
  PendingReview = 'PendingReview',
  Terminated = 'Terminated',
  Completed = 'Completed',
  Submitted = 'Submitted',
  WaitingForReview = 'WaitingForReview',
}
export default ApplicationReviewStatus;
